var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dp-grid-rows"},[_c('RecycleScroller',{ref:"virtualList",staticStyle:{"height":"100%"},attrs:{"items":_vm.data,"item-size":40,"key-field":_vm.keyField},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
var index = ref.index;
return _c('dp-grid-row',{class:[
        ("is-row-" + index),
        {
          'dp-grid-row--odd': index % 2 !== 0,
          'dp-grid-row--selectable': _vm.selectable,
        }
      ],attrs:{"device":item,"columns":_vm.columns,"settings":_vm.settings,"selections":_vm.selections,"kpi":_vm.kpi},on:{"click":function (e) { return _vm.clickRow(e, item, index); }}})}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }